import { useState } from "react";
import { faqs } from "@/mocks/news";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" aria-label="常见问题" className="w-full scroll-mt-24">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10">
        <div className="lg:col-span-4">
          <span className="inline-flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600 mb-2">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-question-line"></i>
            </span>
            常见问题
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950 tracking-tight">
            关于沸点爆料，你想知道的
          </h2>
          <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
            这里整理了读者最常问到的问题。如果还有疑问，欢迎通过联系页面向我们反馈。
          </p>
        </div>

        <div className="lg:col-span-8">
          <div className="border border-background-200 rounded-lg overflow-hidden bg-background-50">
            {faqs.map((faq, index) => {
              const isOpen = openIndex === index;
              return (
                <div key={faq.q} className="border-b border-background-200 last:border-b-0">
                  <h3>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? null : index)}
                      aria-expanded={isOpen}
                      className="w-full flex items-center justify-between gap-4 px-4 md:px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
                    >
                      <span className="font-heading font-bold text-sm md:text-base text-foreground-950">{faq.q}</span>
                      <span
                        className={`shrink-0 w-6 h-6 flex items-center justify-center rounded-md text-foreground-600 transition-transform ${
                          isOpen ? "rotate-45 bg-primary-100 text-primary-700" : "bg-background-200"
                        }`}
                      >
                        <i className="ri-add-line"></i>
                      </span>
                    </button>
                  </h3>
                  <div className={`overflow-hidden transition-all duration-300 ${isOpen ? "max-h-96" : "max-h-0"}`}>
                    <p className="px-4 md:px-5 pb-4 text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}